export const CURRENCIES = [
  { code: 'USD', name: 'US Dollar',          flag: '🇺🇸', symbol: '$'   },
  { code: 'EUR', name: 'Euro',               flag: '🇪🇺', symbol: '€'   },
  { code: 'GBP', name: 'British Pound',      flag: '🇬🇧', symbol: '£'   },
  { code: 'CAD', name: 'Canadian Dollar',    flag: '🇨🇦', symbol: 'CA$' },
  { code: 'AUD', name: 'Australian Dollar',  flag: '🇦🇺', symbol: 'A$'  },
  { code: 'CHF', name: 'Swiss Franc',        flag: '🇨🇭', symbol: 'Fr ' },
  { code: 'JPY', name: 'Japanese Yen',       flag: '🇯🇵', symbol: '¥'   },
  { code: 'CNY', name: 'Chinese Yuan',       flag: '🇨🇳', symbol: '¥'   },
  { code: 'INR', name: 'Indian Rupee',       flag: '🇮🇳', symbol: '₹'   },
  { code: 'MXN', name: 'Mexican Peso',       flag: '🇲🇽', symbol: '$'   },
  { code: 'BRL', name: 'Brazilian Real',     flag: '🇧🇷', symbol: 'R$'  },
  { code: 'KRW', name: 'South Korean Won',   flag: '🇰🇷', symbol: '₩'   },
  { code: 'SGD', name: 'Singapore Dollar',   flag: '🇸🇬', symbol: 'S$'  },
  { code: 'HKD', name: 'Hong Kong Dollar',   flag: '🇭🇰', symbol: 'HK$' },
  { code: 'NOK', name: 'Norwegian Krone',    flag: '🇳🇴', symbol: 'kr ' },
  { code: 'SEK', name: 'Swedish Krona',      flag: '🇸🇪', symbol: 'kr ' },
  { code: 'DKK', name: 'Danish Krone',       flag: '🇩🇰', symbol: 'kr ' },
  { code: 'NZD', name: 'New Zealand Dollar', flag: '🇳🇿', symbol: 'NZ$' },
  { code: 'ZAR', name: 'South African Rand', flag: '🇿🇦', symbol: 'R '  },
  { code: 'AED', name: 'UAE Dirham',         flag: '🇦🇪', symbol: 'د.إ' },
  { code: 'TRY', name: 'Turkish Lira',       flag: '🇹🇷', symbol: '₺'   },
  { code: 'PLN', name: 'Polish Zloty',       flag: '🇵🇱', symbol: 'zł ' },
  { code: 'THB', name: 'Thai Baht',          flag: '🇹🇭', symbol: '฿'   },
  { code: 'IDR', name: 'Indonesian Rupiah',  flag: '🇮🇩', symbol: 'Rp ' },
];

export const CURRENCY_SYMBOLS = Object.fromEntries(CURRENCIES.map(c => [c.code, c.symbol]));
export const NO_DECIMALS = ['JPY', 'KRW', 'IDR'];

export function fmt(n, currency = 'USD') {
  const sym = CURRENCY_SYMBOLS[currency] || (currency + ' ');
  const isNeg = n < 0;
  const abs = Math.abs(n);
  const decimals = NO_DECIMALS.includes(currency) ? 0 : 0;
  const formatted = Math.round(abs).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return (isNeg ? '-' : '') + sym + formatted;
}

export const FALLBACK_RATES = {
  USD:1, EUR:0.918, GBP:0.787, CAD:1.356, AUD:1.535, CHF:0.882,
  JPY:149.2, CNY:7.241, INR:83.1, MXN:17.15, BRL:4.97, KRW:1327,
  SGD:1.341, HKD:7.822, NOK:10.54, SEK:10.41, DKK:6.84, NZD:1.629,
  ZAR:18.63, AED:3.673, TRY:32.1, PLN:3.94, THB:35.1, IDR:15650
};
